// itemGroupBuckets.ts
// Shared item-group bucketing for the custom-page New-Arrivals-style blocks.
//
// Both the Collection Cards block (which renders the per-item-group sections)
// and the Item Group Tiles block (whose tiles scroll to those sections) must
// agree on the SAME bucket name and section anchor id, or scroll-to-section
// silently breaks. Keeping the mapping here guarantees they can't drift.
//
// Mirrors the New Arrivals page's mapToStandardCategory: map by item-group CODE
// into five fixed buckets; anything that isn't Fabric/Wallpaper/Rugs/Furniture
// is merged into Homeware. Mapping by code (not item_group_name) keeps "Rugs"
// aligned with "Rugs and Runners" and folds the small homeware item groups
// (Bathroom 016, Decorative 010, Scatters 018, …) into one Homeware section.

export const NEW_ARRIVALS_ORDER = ['Fabric', 'Wallpaper', 'Rugs and Runners', 'Furniture', 'Homeware'];

// A custom page tile (e.g. a custom "Fabric" page replacing the Fabric item group)
// has no item group of its own, so callers can pass the tile's own name as a
// fallback; otherwise it would fall through to Homeware.
export const mapToStandardBucket = (
  itemGroup?: string | null,
  itemGroupName?: string | null,
  fallbackName?: string | null
): string => {
  const code = itemGroup ?? '';
  const name = (itemGroupName || fallbackName || '').toLowerCase();
  if (name === 'fabric' || code === '005') return 'Fabric';
  if (name === 'wallpaper' || code === '001') return 'Wallpaper';
  if (name === 'rugs' || code === '004') return 'Rugs and Runners';
  if (name === 'furniture' || code === '009') return 'Furniture';
  return 'Homeware';
};

// Slug used for the section anchor id, e.g. "Rugs and Runners" -> "rugs-and-runners".
export const sectionSlug = (name: string): string =>
  name.toLowerCase().trim().replace(/\s+/g, '-');

export const sectionAnchorId = (name: string): string => `section-${sectionSlug(name)}`;
